/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */

import React, { useState, useEffect, useMemo, useContext } from "react";
import { AuthContext } from "../../../Context/AuthContext";
import { useParams, useNavigate } from "react-router-dom";
import {
  getCreditCardLoanById,
  updateCreditCardLoan,
  getAllAdmins,
  getAllCities,
  getCreditCardLoanByMobile,
  getAllStates,
  getAllPincode,
  getCreditCardLoanByEmail,
} from "../../../middleware/backend_hepler";
import LabeledInput from "../../../components/LabeledInput";
import LabeledSelect from "../../../components/LabeledSelect";
import LabeledSelectAgent from "../../../components/LabeledSelectAgent";
import LabeledDropDown from "../../../components/LabeledDropDown";
import { Stepper, Step, StepLabel } from "@mui/material";
import { Row, Col, Button } from "react-bootstrap";
import { useForm, FormProvider } from "react-hook-form";
import { validationRules } from "../../../utils/validationRules";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../../../components/Loader";

const EditCreditCardForm = () => {
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(true);
  const { id } = useParams();
  const navigate = useNavigate();
    const [activeStep, setActiveStep] = useState(0);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [cityOptions, setCityOptions] = useState([]);
  const [hasCreditCard, setHasCreditCard] = useState("");
  const [pincodenumber, setPincode] = useState([]);
  const [pincodeOptions, setPincodeOptions] = useState([]);
  const [error, setError] = useState(null);
  const [emailExists, setEmailExists] = useState(false);
  const [initialEmail, setInitialEmail] = useState("");
  const [mobileExists, setMobileExists] = useState(false);
  const [initialMobile, setInitialMobile] = useState("");
  const { adminRole, adminName, adminId } = useContext(AuthContext);
  const [status, setStatus] = useState("");

  const steps = ["Personal Details", "Loan Details", "Upload Documents"];

  const methods = useForm({
    defaultValues: {
      created_id: "",
      created_by: "",
      assigned_to: "",
      status: "",
      rejected_reason: "",
      employee_type: "",
      name: "",
      mobile: "",
      email: "",
      address: "",
      state: "",
      city: "",
      pincode: "",
      gender: "",
      date_of_birth: "",
      occupation: "",
      highest_education: "",
      marital_status: "",
      credit_score: "",
      own_house: "",
      monthly_income: "",
      mortgage_payment_monthly: "",
      insure_credit_card: "",
      pan: null,
      aadhar: null,
      photo: null,
      bank_account: null,
      itr: null,
      gst_others: null,
    },
    mode: "onChange",
    reValidateMode: "onChange",
  });

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
    reset,
  } = methods;
  const [showPassport, setShowPassport] = useState(false);
  const insureCreditCard = watch("insure_credit_card");
  React.useEffect(() => {
    setShowPassport(insureCreditCard === "Yes");
  }, [insureCreditCard]);

  const email = watch("email");
  const mobile = watch("mobile");

  const handleStatusChange = (e) => {
    setStatus(e.target.value);
  };

  useEffect(() => {
    const fetchCities = async () => {
      setLoading(true);
      setError(null);

      try {
        const citiesData = await getAllCities();
        console.log("Fetched cities data:", citiesData);
        const tamilNaduCities = citiesData
          .filter((city) => city.State_name === "Tamil Nadu")
          .sort((a, b) => a.name.localeCompare(b.name));

        setCities(tamilNaduCities);
        setLoading(true);
        const options = tamilNaduCities.map((city) => ({
          value: city.name,
          label: city.name,
        }));
        setCityOptions(options);
      } catch (error) {
        console.error("Error fetching cities:", error);
        setError("Failed to load cities data. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchCities();
  }, []);

  useEffect(() => {
    const fetchStates = async () => {
      setLoading(true);
      setError(null);
      try {
        const statesData = await getAllStates();
        const availableStates = statesData.filter(
          (state) => state.availability === "Yes"
        );
        setStates(availableStates);

        localStorage.setItem("statesData", JSON.stringify(availableStates));
      } catch (error) {
        console.error("Error fetching states data:", error);
        setError("Failed to load states data. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchStates();
  }, []);

  const stateOptions = useMemo(
    () =>
      states.map((state) => ({
        value: state.name,
        label: state.name,
      })),
    [states]
  );

  useEffect(() => {
    const fetchPinCode = async () => {
      setLoading(true);
      setError(null);
      try {
        const pincodeData = await getAllPincode();
        const tamilNaduStates = pincodeData
          .filter((pincode) => pincode.state === "TAMIL NADU")
          .sort((a, b) => Number(a.pincode) - Number(b.pincode));
        const uniquePincodes = Array.from(
          new Set(tamilNaduStates.map((p) => p.pincode))
        );
        setPincode(uniquePincodes);
        setPincodeOptions(
          uniquePincodes.map((pincode) => ({
            value: pincode,
            label: pincode,
          }))
        );
      } catch (error) {
        console.error("Error fetching pincodes:", error);
        setError("Failed to load pincode data. Please try again later.");
      } finally {
        setLoading(false);
      }
    };
    fetchPinCode();
  }, []);

  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        const response = await getAllAdmins();
        const filteredEmployees = response.filter(
          (admin) => admin.role === "employee"
        );
        setEmployees(filteredEmployees);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.error("Error fetching employees:", error);
      }
    };

    fetchEmployees();
  }, []);

  useEffect(() => {
    const fetchLoanData = async () => {
      try {
        const loan = await getCreditCardLoanById(id);
        Object.keys(loan).forEach((key) => {
          setValue(key, loan[key]);
        });
        setInitialEmail(loan.email);
        setInitialMobile(loan.mobile);
      } catch (error) {
        console.error("Error fetching creditcard loan data:", error);
      }
    };

    fetchLoanData();
  }, [id, setValue]);

  const checkEmail = async (email) => {
    if (email && email !== initialEmail) {
      try {
        const data = await getCreditCardLoanByEmail(email);
        setEmailExists(Boolean(data));
      } catch (error) {
        setEmailExists(false);
      }
    } else {
      setEmailExists(false);
    }
  };

  const checkMobile = async (mobile) => {
    if (mobile && mobile !== initialMobile) {
      try {
        const data = await getCreditCardLoanByMobile(mobile);
        setMobileExists(Boolean(data));
      } catch (error) {
        setMobileExists(false);
      }
    } else {
      setMobileExists(false);
    }
  };

  useEffect(() => {
    if (email) {
      checkEmail(email);
    }
  }, [email]);

  useEffect(() => {
    if (mobile) {
      checkMobile(mobile);
    }
  }, [mobile]);

  const getInitials = (name) => {
    if (!name) return "";
    const names = name.split(" ");
    const initials = names.map((n) => n.charAt(0).toUpperCase()).join("");
    return initials;
  };

  const employeeOptions = employees.map((employee) => ({
    value: `ID${employee.id} - ${employee.name}`,
    label: (
      <div className="agent-option">
        {employee.photo ? (
          <img
            src={decodeURIComponent(employee.photo)}
            alt={`${employee.name}'s avatar`}
            className="agent-image"
          />
        ) : (
          <div className="agent-image-initials">{getInitials(employee.name)}</div>
        )}
        <span className="agent-details">
          <strong>ID{employee.id}</strong> - {employee.name}
        </span>
      </div>
    ),
  }));

  const handleCreditCardChange = (event) => {
    setHasCreditCard(event.target.value);
  };
  const onSubmit = async (data) => {
    const formDataToSend = new FormData();
    Object.keys(data).forEach((key) => {
      if (data[key]) {
        formDataToSend.append(key, data[key]);
      }
    });

    try {
      await updateCreditCardLoan(id, formDataToSend);
      navigate("/creditcardlist", {
        state: { successMessage: "Creditcard loan updated successfully!" },
      });
    } catch (error) {
      const errorMessage = error.response?.data?.message;

      if (typeof errorMessage === "string") {
        if (errorMessage.includes("Email already exists")) {
          toast.error("Email already exists. Please use a different email.");
        }
        if (errorMessage.includes("Mobile number already exists")) {
          toast.error(
            "Mobile number already exists. Please use a different mobile number."
          );
        }
        // In case both are mentioned in a single message
        if (errorMessage.includes("Mobile number or email already exists")) {
          toast.error(
            "Mobile number or email already exists. Please use different details."
          );
        }
      } else {
        console.error("Error updating creditcard loan:", error);
        toast.error("Failed to update the creditcard loan. Please try again.");
      }
    }
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    if (files.length > 0) {
      setValue(name, files[0]);
    }
  };

  const handleViewClick = async (documentType) => {
    try {
      const loan = await getCreditCardLoanById(id);
      let url = loan[documentType];

      if (url) {
        url = decodeURIComponent(url);
        window.open(url, "_blank");
      } else {
        console.warn(`No URL found for ${documentType}`);
      }
    } catch (error) {
      console.error(`Error fetching ${documentType} document:`, error);
    }
  };

  const handleStepChange = async (newStep) => {
    if (newStep === 1) {
      const isValidStep0 = await methods.trigger();
      if (isValidStep0) {
        if (emailExists) {
          toast.error("Email already exists. Please use a different email.");
          return;
        }
        if (mobileExists) {
          toast.error(
            "Mobile number already exists. Please use a different mobile number."
          );
          return;
        }
        setActiveStep(newStep);
      } else {
        console.log(
          "Please fix validation errors before moving to the next step."
        );
      }
    } else if (newStep === 2) {
      const isValidStep1 = await methods.trigger();
      if (isValidStep1) {
        setActiveStep(newStep);
      } else {
        console.log(
          "Please fix validation errors before moving to the next step."
        );
      }
    } else {
      setActiveStep(newStep);
    }
  };

  if (loading) {
    return <Loader />;
  }
  if (error) {
    return <div>{error}</div>;
  }

  return (
    <div className="edit-all-loan-container">
      {activeStep === 0 && (
        <div className="edit-back-icon">
          <div
            className="edit-back-text"
            onClick={() => navigate("/creditcardlist")}
          >
            &lt; Go Back
          </div>
        </div>
      )}
      <h2>Credit Card</h2>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Stepper
            activeStep={activeStep}
            alternativeLabel
            className="stepper-container"
          >
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
          <div className="form-content">
            {activeStep === 0 && (
              <div className="sections personal-details-sections">
                <h4>Personal Details</h4>
                <div className="form-row">
                  <LabeledInput
                    label="Employee ID"
                    name="created_id"
                    disabled={true}
                    style={{ backgroundColor: "#f0f0f0", color: "#808080" }}
                    registerOptions={{}}
                  />
                  <LabeledInput
                    label="Employee"
                    name="created_by"
                    disabled={true}
                    style={{ backgroundColor: "#f0f0f0", color: "#808080" }}
                    registerOptions={{}}
                  />
                </div>
                <div className="form-row">
                  {adminRole === "admin" && (
                    <LabeledSelect
                      name="assigned_to"
                      label="Assign to"
                      registerOptions={{ required: "Selection is required" }}
                      error={errors.assigned_to?.message}
                      options={employeeOptions}
                      required
                    />
                  )}
                  <LabeledDropDown
                    name="status"
                    label="Lead Status"
                    options={[
                      { value: "Open", label: "Open" },
                      { value: "In Process", label: "In Process" },
                      { value: "Pending", label: "Pending" },
                      { value: "Approved", label: "Approved" },
                      { value: "Rejected", label: "Rejected" },
                    ]}
                    registerOptions={{
                      required: "Selection is required",
                      onChange: (e) => {
                        handleStatusChange(e);
                        setValue("status", e.target.value);
                      },
                    }}
                    error={errors.status?.message}
                    required
                  />
                  {watch("status") === "Rejected" && (
                    <LabeledDropDown
                      name="rejected_reason"
                      label="Rejected Reason"
                      options={[
                        {
                          value: "CIBIL issue & more than 3 enquiries",
                          label: "CIBIL issue & more than 3 enquiries",
                        },
                        {
                          value: "Recent loan/settlement",
                          label: "Recent loan/settlement",
                        },
                        { value: "Recent DPD", label: "Recent DPD" },
                        {
                          value: "Overdue / Previous loan (HL/PL/BL/CL)",
                          label: "Overdue / Previous loan (HL/PL/BL/CL)",
                        },
                        {
                          value: "Lowest CIBIL score",
                          label: "Lowest CIBIL score",
                        },
                        {
                          value: "Guarantor CIBIL score / Co-Applicant issue",
                          label: "Guarantor CIBIL score / Co-Applicant issue",
                        },
                        {
                          value: "Pincode / Salary / Age criteria not met",
                          label: "Pincode / Salary / Age criteria not met",
                        },
                        {
                          value: "Can apply after 3 months",
                          label: "Can apply after 3 months",
                        },
                        {
                          value: "Never eligible for loan",
                          label: "Never eligible for loan",
                        },
                        {
                          value: "Credit card overdue",
                          label: "Credit card overdue",
                        },
                      ]}
                      registerOptions={{ required: "Selection is required" }}
                      error={errors.rejected_reason?.message}
                      required
                    />
                  )}
                </div>
                <div className="form-row">
                  <LabeledInput
                    label="Name"
                    type="text"
                    name="name"
                    registerOptions={validationRules.name}
                    error={errors.name?.message}
                    required
                  />
                  <LabeledDropDown
                    label="Gender"
                    type="text"
                    name="gender"
                    options={[
                      { value: "Male", label: "Male" },
                      { value: "Female", label: "Female" },
                      { value: "Other", label: "Other" },
                    ]}
                    registerOptions={{ required: "Gender is required" }}
                    error={errors.gender?.message}
                    required
                  />
                </div>
                <div className="form-row">
                  <LabeledInput
                    label="Mobile"
                    type="tel"
                    name="mobile"
                    registerOptions={validationRules.mobile}
                    error={errors.mobile?.message}
                    required
                  />
                  <LabeledInput
                    label="Email"
                    type="text"
                    name="email"
                    registerOptions={validationRules.email}
                    error={errors.email?.message}
                    required
                  />
                </div>
                <div className="form-row">
                  <LabeledInput
                    label="Date of Birth"
                    type="date"
                    name="date_of_birth"
                    registerOptions={{
                      required: "Date of Birth is required",
                      validate: (value) => {
                        const today = new Date();
                        const dob = new Date(value);
                        const age = today.getFullYear() - dob.getFullYear();
                        const monthDifference =
                          today.getMonth() - dob.getMonth();

                        // Check if the birthday hasn't occurred yet this year
                        if (
                          monthDifference < 0 ||
                          (monthDifference === 0 &&
                            today.getDate() < dob.getDate())
                        ) {
                          return (
                            age > 21 || "You must be at least 21 years old."
                          );
                        }

                        return (
                          age >= 21 || "You must be at least 21 years old."
                        );
                      },
                    }}
                    error={errors.date_of_birth?.message}
                    required
                  />
                  <LabeledDropDown
                    label="Marital Status"
                    type="text"
                    name="marital_status"
                    options={[
                      { value: "Single", label: "Single" },
                      { value: "Married", label: "Married" },
                      { value: "Divorced", label: "Divorced" },
                      { value: "Widow", label: "Widow" },
                    ]}
                    registerOptions={{ required: "Marital Status is required" }}
                    error={errors.marital_status?.message}
                    required
                  />
                </div>
                <div className="form-row">
                  <LabeledInput
                    label="Address"
                    type="text"
                    name="address"
                    registerOptions={{ required: "Address is required" }}
                    error={errors.address?.message}
                    required
                  />
                  <LabeledSelect
                    label="City"
                    name="city"
                    options={cityOptions}
                    registerOptions={{ required: "City is required" }}
                    error={errors.city?.message}
                    required
                  />
                </div>
                <div className="form-row">
                  <LabeledSelect
                    name="state"
                    label="State"
                    registerOptions={{ required: "State is required" }}
                    error={errors.state?.message}
                    options={stateOptions}
                    required
                  />
                  <LabeledSelectAgent
                    label="Pincode"
                    type="text"
                    name="pincode"
                    options={pincodeOptions}
                    registerOptions={validationRules.Pincode}
                    error={errors.pincode?.message}
                    required
                  />
                </div>
              </div>
            )}
            {activeStep === 1 && (
              <div className="details-sections">
                <div className="form-row">
                  <LabeledDropDown
                    name="employee_type"
                    label="Employee Type"
                    options={[
                      { value: "salaried", label: "Salaried" },
                      { value: "self employed", label: "Self Employed" },
                    ]}
                    registerOptions={{ required: "Employee Type is required" }}
                  />
                  <LabeledInput
                    label="Occupation"
                    type="text"
                    name="occupation"
                    registerOptions={{ required: "Occupation is required" }}
                    error={errors.occupation?.message}
                    required
                  />
                  <LabeledDropDown
                    label="Highest Education"
                    name="highest_education"
                    options={[
                      { value: "University", label: "University" },
                      { value: "College", label: "College" },
                      { value: "Secondary", label: "Secondary" },
                      { value: "Primary", label: "Primary" },
                      { value: "Other", label: "Other" },
                    ]}
                    registerOptions={{
                      required: "Highest Education is required",
                    }}
                    error={errors.highest_education?.message}
                    required
                  />
                  <LabeledDropDown
                    label="Own House"
                    name="own_house"
                    options={[
                      { value: "Yes", label: "Yes" },
                      { value: "No", label: "No" },
                    ]}
                    registerOptions={{
                      required: "Home Ownership status is required",
                    }}
                    required
                  />
                </div>
                <div className="form-row"></div>
                <div className="form-row">
                  <LabeledDropDown
                    label="Already have a credit card?"
                    name="insure_credit_card"
                    options={[
                      { value: "Yes", label: "Yes" },
                      { value: "No", label: "No" },
                    ]}
                    register={register}
                  />

                  {showPassport && (
                    <div className="form-row">
                      <LabeledInput
                        name="credit_score"
                        label="Credit Card Limit"
                        type="number"
                        registerOptions={{
                          required: "Credit Card Limit is required",
                        }}
                        error={errors.credit_score?.message}
                        register={register}
                      />
                    </div>
                  )}
                </div>
              </div>
            )}
            {activeStep === 2 && (
              <div className="sections financial-details-sections">
                <div className="form-row">
                  <div className="sections document-upload-sections">
                    <div className="document-upload-group">
                      <label htmlFor="pan" className="document-label">
                        PAN Card
                      </label>
                      <div className="document-file-container">
                        <input
                          label="PAN Card"
                          type="file"
                          name="pan"
                          onChange={handleFileChange}
                          className="form-control-file"
                        />
                      </div>
                      <button
                        type="button"
                        className="view-btn"
                        onClick={() => handleViewClick("pan")}
                      >
                        View
                      </button>
                    </div>
                    <div className="document-upload-group">
                      <label htmlFor="aadhar" className="document-label">
                        Aadhaar Card
                      </label>
                      <div className="document-file-container">
                        <input
                          label="Aadhar Card"
                          type="file"
                          name="aadhar"
                          onChange={handleFileChange}
                          className="form-control-file"
                        />
                      </div>
                      <button
                        type="button"
                        className="view-btn"
                        onClick={() => handleViewClick("aadhar")}
                      >
                        View
                      </button>
                    </div>
                    <div className="document-upload-group">
                      <label htmlFor="photo" className="document-label">
                        Photo
                      </label>
                      <div className="document-file-container">
                        <input
                          label="Photo"
                          type="file"
                          name="photo"
                          onChange={handleFileChange}
                          className="form-control-file"
                        />
                      </div>
                      <button
                        type="button"
                        className="view-btn"
                        onClick={() => handleViewClick("photo")}
                      >
                        View
                      </button>
                    </div>
                    <div className="document-upload-group">
                      <label htmlFor="bank_account" className="document-label">
                        SB Account
                      </label>
                      <div className="document-file-container">
                        <input
                          label="SB Account"
                          type="file"
                          name="bank_account"
                          onChange={handleFileChange}
                          className="form-control-file"
                        />
                      </div>
                      <button
                        type="button"
                        className="view-btn"
                        onClick={() => handleViewClick("bank_account")}
                      >
                        View
                      </button>
                    </div>
                    <div className="document-upload-group">
                      <label htmlFor="itr" className="document-label">
                        IT Return
                      </label>
                      <input
                        label="IT Return"
                        type="file"
                        name="itr"
                        onChange={handleFileChange}
                        className="form-control-file"
                      />
                      <button
                        type="button"
                        className="view-btn"
                        onClick={() => handleViewClick("itr")}
                      >
                        View
                      </button>
                    </div>
                    <div className="document-upload-group">
                      <label htmlFor="gst_others" className="document-label">
                        GST Certificate
                      </label>
                      <input
                        label="GST Certificate"
                        type="file"
                        name="gst_others"
                        onChange={handleFileChange}
                        className="form-control-file"
                      />
                      <button
                        type="button"
                        className="view-btn"
                        onClick={() => handleViewClick("gst_others")}
                      >
                        View
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="button-container">
            <Row className="mt-4">
              <Col className="text-end">
                {activeStep > 0 && (
                  <Button
                    variant="secondary"
                    onClick={() => handleStepChange(activeStep - 1)}
                    className="custom-back-button"
                  >
                    Go Back
                  </Button>
                )}
                {activeStep < steps.length - 1 && (
                  <Button
                    variant="primary"
                    onClick={() => handleStepChange(activeStep + 1)}
                    className="custom-next-button"
                  >
                    Next Step
                  </Button>
                )}
                {activeStep === steps.length - 1 && (
                  <Button
                    type="submit"
                    variant="primary"
                    className="custom-submit-button"
                  >
                    Update
                  </Button>
                )}
              </Col>
            </Row>
          </div>
        </form>
      </FormProvider>
      <ToastContainer />
    </div>
  );
};

export default EditCreditCardForm;
